import script from "./TablePagination.vue?vue&type=script&lang=ts&setup=true"
export * from "./TablePagination.vue?vue&type=script&lang=ts&setup=true"

import "./TablePagination.vue?vue&type=style&index=0&id=42f5a500&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42f5a500"]])

export default __exports__